var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserQuestionMark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16.0059C10.205 16.0059 12 14.2109 12 12.0059C12 9.80086 10.205 8.00586 8 8.00586C5.794 8.00586 4 9.80086 4 12.0059C4.001 14.2109 5.794 16.0059 8 16.0059Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 17.0059C3.289 17.0059 0 19.4729 0 23.0059V24.0059H16V23.0059C16 19.4729 12.71 17.0059 8 17.0059Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 9.00586H19V6.00586H20C21.103 6.00586 22 5.10786 22 4.00586C22 2.90186 21.103 2.00586 20 2.00586C18.896 2.00586 18 2.90186 18 4.00586H16C16 1.80086 17.794 0.00585938 20 0.00585938C22.205 0.00585938 24 1.80086 24 4.00586C24 5.86586 22.723 7.43386 21 7.87986V9.00586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12.0059C20.5523 12.0059 21 11.5581 21 11.0059C21 10.4536 20.5523 10.0059 20 10.0059C19.4477 10.0059 19 10.4536 19 11.0059C19 11.5581 19.4477 12.0059 20 12.0059Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserQuestionMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-question-mark.4f7cf7b58b2dc11209caa0a026e5efc6.svg";